import { useContext } from 'react';
import { message } from 'antd';
import { FormActionContext } from '../context';
import { createAlert } from '@src/api/manualAlerts';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { trackQueryError } from '@src/utils/sensor/apptracker';

const useCreateAlert = (setSaving) => {
  const queryClient = useQueryClient();
  const {
    actions: { onCancel },
  } = useContext(FormActionContext);

  const mutation = useMutation(
    (payload) => {
      return createAlert(payload);
    },
    {
      onSuccess: (response) => {
        const { name } = response.data;
        onCancel();
        setSaving(false);
        queryClient.invalidateQueries(['manual-alert', 'list']);
        message.success(`Alert "${name}" created successfully`);
      },
      onError: (err) => {
        trackQueryError({ type: 'manual-alert-create', err });
      },
    },
  );

  return mutation;
};

export default useCreateAlert;
